import { ActiveCamera } from 'types/CarTracking';

export const mockPropertyViewCameras: ActiveCamera[] = [
    {
        id: 718,
        notes: 'Tripwire #322 - East Entry',
        orientation: 'Entrance',
        coordinates: null,
        is_active: true,
    },
    {
        id: 927,
        notes: 'Tripwire #341 - East Exit',
        orientation: 'Exit',
        coordinates: null,
        is_active: true,
    },
    {
        id: 748,
        notes: 'Tripwire #350 - West Exit',
        orientation: 'Exit',
        coordinates: null,
        is_active: true,
    },
    {
        id: 942,
        notes: 'Tripwire #352 - North Entry',
        orientation: 'Entrance',
        coordinates: null,
        is_active: true,
    },
    {
        id: 943,
        notes: 'Tripwire #356 - West Entry',
        orientation: 'Entrance',
        coordinates: null,
        is_active: true,
    },
    {
        id: 166,
        notes: 'Washington Hill AirHunter',
        orientation: 'Top',
        coordinates: [39.294478, -76.589879],
        is_active: true,
        latest_image: {
            camera_id: 166,
            name: 'Washington Hill AirHunter',
            image_url: 'https://storage.googleapis.com/yellowstone_8579/1720196945.jpg',
            event_datetime: 1720196945,
            coordinates: [39.294478, -76.589879],
        },
    },
    {
        id: 232,
        notes: 'Washington Hill AirHunter 002',
        orientation: 'Top',
        coordinates: [39.295088, -76.590128],
        is_active: true,
        latest_image: {
            camera_id: 232,
            name: 'Washington Hill AirHunter 002',
            image_url: 'https://storage.googleapis.com/yellowstone_8579/1720196945.jpg',
            event_datetime: 1720196845,
            coordinates: [39.295088, -76.590128],
        },
    },
    {
        id: 272,
        notes: 'Washington Hill AirHunter 003',
        orientation: 'Top',
        coordinates: [39.294781, -76.589895],
        is_active: true,
        latest_image: {
            camera_id: 272,
            name: 'Washington Hill AirHunter 003',
            image_url: 'https://storage.googleapis.com/yellowstone_8579/1720196945.jpg',
            event_datetime: 1720196745,
            coordinates: [39.294781, -76.589895],
        },
    },
    {
        id: 273,
        notes: 'Washington Hill AirHunter 004',
        orientation: 'Top',
        coordinates: [39.294774, -76.590105],
        is_active: true,
        latest_image: {
            camera_id: 273,
            name: 'Washington Hill AirHunter 004',
            image_url: 'https://storage.googleapis.com/yellowstone_8579/1720196945.jpg',
            event_datetime: 1720196645,
            coordinates: [39.294774, -76.590105],
        },
    },
];

export const mockPropertyViewCamerasWithNoCoordinates: ActiveCamera[] = [
    {
        id: 1,
        notes: 'Entry',
        orientation: 'Entrance',
        coordinates: null,
        is_active: true,
    },
];

export function getMockPropertyViewCameras(): ActiveCamera[] {
    return mockPropertyViewCameras;
}
